import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { __rest } from "tslib";
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import { Logger } from '@tencent/vft-common/logger';
import KVJoiner from '@tencent/vft-cosmos/base/KVJoiner';
import KVParser from '@tencent/vft-cosmos/base/KVParser';
import { BINDING_TYPES, DEFAULT_BUSINESS, DEFAULT_MODULE_TYPE, MODULE_FIELD_NAME } from "./const";
import { BindingTypes } from "./defs";
export function isFunction(fn) {
  return typeof fn === 'function';
}
var kvParser = new KVParser({
  canSkipEmpty: true
});
/**
 * @description 将a=1&b=2形式的字符串解析成{a:1, b:2}对象
 * @param {String|Record<string, any>} query 参数
 */
export function query2obj(query) {
  return typeof query === 'string' ? kvParser.parse(query) : query;
}
var kvJoiner = new KVJoiner();
/**
 * @description 将对象用=和&拼接成字符串
 * @param {Record<string, any>} o 待拼接的对象
 * @returns {String}
 */
export function obj2query(o) {
  return kvJoiner.add(o).join();
}
function generatePvid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return [s4(), s4(), s4(), s4()].join('');
}
var pvid;
export function getPvid() {
  pvid = pvid || cookie.get('pgv_pvid');
  if (!pvid || pvid.length < 8) {
    // 兜底，如果取不到 pvid 情况下，生成一个pvid
    pvid = generatePvid();
    var domain = /wetv\.vip/.test(location.hostname) ? 'wetv.vip' : 'qq.com';
    cookie.set('pgv_pvid', pvid, {
      expires: 2592000,
      domain: domain,
      path: '/'
    });
  }
  return pvid;
}
// 为了方便单元测试
export function resetPvid() {
  pvid = '';
}
/**
 * 获取上报类型
 * @param {VftReport.DirectiveModifiers} modifiers 指令修饰符
 *
 * @return {VftReport.BindingType}
 */
export function extractBindingType(modifiers) {
  return Object.keys(modifiers).find(function (name) {
    return BINDING_TYPES.includes(name);
  }) || BindingTypes.ALL;
}
/**
 * 处理Vue绑定指令
 * @param binding Vue指令绑定数据
 * @param hook 钩子
 * @returns BindingData
 */
export function parseVueBindingValue(binding, hook) {
  var value = binding.value;
  if (typeof value === 'string') {
    value = query2obj(value);
  }
  var modifiers = binding.modifiers,
    arg = binding.arg;
  /*
   * 快捷处理模块上报
   * <div v-report.module="{模块: { f_module: 'xxx' }}"></div>
   * 上报数据为 { f_module: 'xxx' }
   */
  var type = extractBindingType(modifiers);
  if (type === BindingTypes.MODULE && value[MODULE_FIELD_NAME]) {
    value = value[MODULE_FIELD_NAME];
  }
  return {
    type: type,
    value: value,
    hook: hook,
    once: modifiers.once,
    modifiers: modifiers,
    module: arg
  };
}
export var ScreenType;
(function (ScreenType) {
  ScreenType["REGULAR"] = "regular";
  ScreenType["LARGE"] = "large";
  ScreenType["HUGE"] = "huge";
  ScreenType["MAX"] = "max";
})(ScreenType || (ScreenType = {}));
var screenConfigs = [[ScreenType.REGULAR, 375], [ScreenType.LARGE, 667], [ScreenType.HUGE, 980], [ScreenType.MAX, 1366]];
/**
 *
 * @returns {ScreenType}
 */
export function calculateScreenType() {
  var realScreenWidth = calculateDeviceRealSize(document.documentElement.clientWidth, window.devicePixelRatio);
  return getScreenType(realScreenWidth);
}
export function getScreenType(realScreenWidth) {
  var _iterator = _createForOfIteratorHelper(screenConfigs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        type = _step$value[0],
        size = _step$value[1];
      if (size > realScreenWidth) {
        return type;
      }
    }
    // 如果都小于屏幕尺寸，则返回max
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return screenConfigs[screenConfigs.length - 1][0];
}
export function calculateDeviceRealSize() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement.clientWidth;
  var dpr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.devicePixelRatio;
  var dpi = 1;
  var fixedDpr = dpr;
  if (dpr > 1 && dpr < 3) {
    dpi = 2;
  } else if (dpr >= 3) {
    dpi = 3;
  }
  /*
    2020.5.12
    普通屏幕是160ppi，也就是我们常说的1倍屏幕。
    如果是320ppi，也就是我们常说的2倍屏幕。
    现在所有的设备都是160ppi+，高清的iphone XM 就是458ppi，虽然dpr是3，但其实是不够3倍屏的，所以还是以2倍屏来处理。
    2020.5.26
    有某些特殊的安卓机型dpr居然是4，所以有了以下判断，
  */
  if (dpr >= 4 && env.isAndroid) {
    fixedDpr = 2;
  }
  return fixedDpr * distance / dpi;
}
var boss2dtKeyMap = {
  f_module_id: 'mod_id',
  f_module: 'mod_title',
  f_resource: 'btn_title',
  f_module_type: 'e_module_type'
};
var dt2bossKeyMap = {
  eid: 'f_hottag',
  btn_title: 'f_resource',
  mod_title: 'f_module',
  mod_id: 'f_hottag'
};
export function mapParams(params, mapConfig) {
  var mappedParams = {};
  Object.keys(params).forEach(function (key) {
    var mappedKey = mapConfig[key] || key;
    mappedParams[mappedKey] = params[key];
  });
  return mappedParams;
}
/**
 *
 * @param {ReportParams} params 上报参数
 * @returns
 */
export function mapBoss2DtParams(params) {
  return mapParams(params, boss2dtKeyMap);
}
export function mapDt2BossParams(params) {
  return mapParams(params, dt2bossKeyMap);
}
export function normalizeDtParams(params) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  var _a = mapBoss2DtParams(params),
    f_hottag = _a.f_hottag,
    eid = _a.eid,
    _a$e_module_type = _a.e_module_type,
    e_module_type = _a$e_module_type === void 0 ? DEFAULT_MODULE_TYPE : _a$e_module_type,
    rests = __rest(_a, ["f_hottag", "eid", "e_module_type"]);
  return Object.assign({
    e_module_type: e_module_type,
    business: DEFAULT_BUSINESS
  }, rests);
}
export var logger = new Logger('vft-report');
/**
 * 判断是否是类Promise对象
 * @param {any} target
 * @returns Boolean
 */
export function isPromisable(target) {
  if (!target) {
    return false;
  }
  return isFunction(target.then) && isFunction(target.catch);
}
/**
 * location.pathname有三种等价的格式
 * 1. /xx/index.html
 * 2. /xx/
 * 3. /xx
 * 此函数将传入的pathname标准化为第二种格式
 * @param {String} pathname 原始的pathname，一般取location.pathname
 * @returns {String} 标准化后的pathname
 */
export function normalizePath(pathname) {
  if (/\/$/.test(pathname)) {
    // 以/结尾的直接返回
    return pathname;
  }
  var matches = pathname.match(/(.*\/)(.*?(\.html)?)$/);
  if (!matches) {
    return pathname;
  }
  var _matches = _slicedToArray(matches, 4),
    match = _matches[0],
    path = _matches[1],
    file = _matches[2],
    extname = _matches[3];
  // 以具体html文件名结尾的
  if (extname === '.html') {
    // 如果是index.html，则去掉index.html，如果是其它文件名，返回原路径
    return file === 'index.html' ? path : match;
  }
  // 否则就是以目录结尾，并且尾部没有/，需要补齐/
  return "".concat(path).concat(file, "/");
}